import React from 'react';
import { Header } from './components/Header';
import { TopBanner } from './components/TopBanner';
import { HeroSection } from './components/HeroSection';
import { ComparisonTable } from './components/ComparisonTable';
import { ProblemSection } from './components/ProblemSection';
import { SuccessStories } from './components/SuccessStories';
import { ProjectCarousel } from './components/ProjectCarousel';
import { ProductPresentation } from './components/ProductPresentation';
import { WhatYouGet } from './components/WhatYouGet';
import { BonusGrid } from './components/BonusGrid';
import { TrustSection } from './components/TrustSection';
import { PriceBox } from './components/PriceBox';
import { VideoMockupSection } from './components/VideoMockupSection';
import { FAQSection } from './components/FAQSection';
import { CommentsSection } from './components/CommentsSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { PurchaseNotifications } from './components/PurchaseNotifications';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-screen bg-[#0a0514] font-sans selection:bg-[#00f0ff]/30 selection:text-white text-gray-100" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <TopBanner data-id="element-2" />
      <Header data-id="element-3" />

      <main data-id="element-4">
        <HeroSection data-id="element-5" />
        <ComparisonTable data-id="element-6" />
        <ProblemSection data-id="element-7" />
        <SuccessStories data-id="element-8" />
        <ProjectCarousel data-id="element-9" />
        <ProductPresentation data-id="element-10" />
        <WhatYouGet data-id="element-11" />
        <BonusGrid data-id="element-12" />
        <TrustSection data-id="element-13" />
        <PriceBox data-id="element-14" />
        <VideoMockupSection data-id="element-15" />
        <CommentsSection data-id="element-16" />
        <TestimonialsSection data-id="element-17" />
        <FAQSection data-id="element-18" />
      </main>

      <footer className="bg-[#0a0514] py-12 border-t border-[#27272a] text-center" role="contentinfo" data-id="element-19">
        <div className="max-w-7xl mx-auto px-4" data-id="element-20">
          <p className="text-gray-400 text-sm mb-4" data-id="element-21">
            © 2026 sin fin studio. Todos los derechos reservados.
          </p>
          <p className="text-gray-400 text-xs max-w-2xl mx-auto leading-relaxed" data-id="element-22">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
          </p>
        </div>
      </footer>

      <PurchaseNotifications data-id="element-23" />
    </div>;
}